const Services = () => {
  return (
    <div>
      <h1>Contact Page Coming Up soon!!</h1>
    </div>
  );
}

export default Services;